export enum ExecutionState {
  nostate = 0,
  loading = 1,
  success = 2,
  error = 3,
}
